module.exports = __webpack_public_path__ + "img/table-option-icon.5c8c3430.svg";